<div class="stack__wrapper">
    <ng-content></ng-content>
</div>
